export default __webpack_public_path__ + "static/media/leafLeft.f83a0a08.png";